export default __webpack_public_path__ + "tmp_src/components/ShippingMessage/ShippingMessage.css.liquid";